/* eslint-disable camelcase */
import { createSelector } from 'reselect';

const selectEditableForm = (state) => state.form.editableForm;

export const selectForm = createSelector([selectEditableForm], (form) => form);

export const selectFormPages = createSelector([selectEditableForm], (form) => form.definition && form.definition.pages);

export const selectFormCalculations = createSelector([selectForm], (form) => form.definition.calculations);

export const selectFormRules = createSelector([selectForm], (form) => form.definition.rules);

export const selectFormDesign = createSelector([selectEditableForm], (form) => {
  const formDesign = {};
  const {
    layout_class,
    submission_button_text,
    save_continue_button_text,
    previous_button_text,
    next_button_text,
    submission_button_background,
    submission_button_position,
    multipage_buttons_position,
    submission_button_type,
    custom_logo_image,
    custom_logo_alignment,
    page_background,
    form_text_color,
    form_font,
    form_font_size,
    form_title_font_size,
    form_external_css,
    form_background_image,
    custom_form_width,
    background_image_size,
    background_image_fixed,
    background_image_repeat,
    underline_title,
    design,
  } = form;

  formDesign.old = {
    layout_class: layout_class || '',
    submission_button_text: submission_button_text || '',
    save_continue_button_text: save_continue_button_text || '',
    previous_button_text: previous_button_text || '',
    next_button_text: next_button_text || '',
    submission_button_background: submission_button_background || '',
    submission_button_position: submission_button_position || '',
    multipage_buttons_position: multipage_buttons_position || '',
    submission_button_type: submission_button_type || '',
    custom_logo_image: custom_logo_image || '',
    custom_logo_alignment: custom_logo_alignment || '',
    page_background: page_background || '',
    form_text_color: form_text_color || '',
    form_font: form_font || 'Quicksand',
    form_font_size: form_font_size || '',
    form_title_font_size: form_title_font_size || '',
    form_external_css: form_external_css || '',
    form_background_image: form_background_image || '',
    custom_form_width: custom_form_width || '',
    background_image_size: background_image_size || '',
    background_image_fixed: background_image_fixed || false,
    background_image_repeat: background_image_repeat || false,
    underline_title: underline_title || false,
  };

  formDesign.design = design;

  return formDesign;
});

export const selectRowControls = createSelector([selectFormPages], (pages) => {
  const rowControls = {};
  for (let i = 0; i < pages.length; i += 1) {
    const pageControls = pages[i].controls;
    for (let j = 0; j < pageControls.length; j += 1) {
      if (pageControls[j].is_row) {
        rowControls[pageControls[j].internal_id] = pageControls[j];
      }
    }
  }
  return rowControls;
});

export const selectLogic = createSelector([selectEditableForm], (form) => {
  // maps triggering_field_ids to list of rules triggered by them
  const triggeringFields = {};
  // maps field IDs to list of rules acting them
  const actionFields = {};

  const { rules } = form.definition;

  for (let r = 0; r < rules.length; r++) {
    const rule = rules[r];
    if (rule.option) {
      rule.actions.forEach((action) => {
        !(action.id in actionFields) && (actionFields[action.id] = []);
        actionFields[action.id].push(rule);
      });
      rule.triggers.forEach((trigger) => {
        !(trigger.id in triggeringFields) && (triggeringFields[trigger.id] = []);
        triggeringFields[trigger.id].push(rule);
      });
    } else if (rule.triggering_field_id) {
      !(rule.triggering_field_id in triggeringFields) && (triggeringFields[rule.triggering_field_id] = []);
      triggeringFields[rule.triggering_field_id].push(rule);
    }
  }
  return { triggeringFields, actionFields };
});

export default {
  selectForm,
  selectFormPages,
  selectFormDesign,
  selectLogic,
};
